// extracted by mini-css-extract-plugin
export default {"user":"UserMenu_user__fnSPK","box":"UserMenu_box__hskRV","item":"UserMenu_item__ay1Hw","text":"UserMenu_text__pptec"};